export default __webpack_public_path__ + "static/media/hotel-locking-encoder-2-246x300.5568c7b8.jpg";